import { gql } from "@apollo/client";

const CREATE_COMMODITIES = gql`
  mutation ItemCreate($inputs: [CreateItemInput!]!) {
    itemCreate(inputs: $inputs) {
      id
      name
      measurementUnit
    }
  }
`;

export { CREATE_COMMODITIES };
